package com.github.jangalinski.tabweb._foundation.alignment

import com.varabyte.kobweb.compose.ui.Alignment

data object BOTTOM : Vertical, CardinalDirection {
  val alignment: Alignment.Vertical = Alignment.Bottom
}
